import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, Clock } from 'lucide-react';

const posts = [
  {
    id: 1,
    title: 'Rekordbox XML Is Killing Your Library',
    excerpt:
      'Every XML export erases a little more of your prep work. Here\'s why the lossy serialization problem has only one real fix — and what it took to build it.',
    date: 'May 2026',
    readTime: '8 min read',
    tags: ['DJ', 'Metadata', 'Bonk'],
    slug: 'rekordbox-xml-is-killing-your-library',
  },
];

export default function BlogIndex() {
  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)', paddingTop: 100, paddingBottom: 120 }}>
      <div className="container" style={{ maxWidth: 720, margin: '0 auto', padding: '0 24px' }}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <Link
            to="/"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 8,
              fontSize: 13,
              color: 'var(--gray-3)',
              marginBottom: 48,
              transition: 'color 0.2s',
            }}
            onMouseEnter={e => (e.target.style.color = 'var(--accent)')}
            onMouseLeave={e => (e.target.style.color = 'var(--gray-3)')}
          >
            <ArrowLeft size={13} />
            Back to bonk.
          </Link>

          <div style={{ marginBottom: 56 }}>
            <p style={{ fontSize: 11, letterSpacing: '0.15em', textTransform: 'uppercase', color: 'var(--accent)', marginBottom: 12, fontWeight: 600 }}>
              Writing
            </p>
            <h1 style={{ fontFamily: 'var(--heading)', fontSize: 'clamp(2.5rem, 6vw, 3.5rem)', fontWeight: 800, letterSpacing: '-0.03em', color: 'var(--white)', lineHeight: 1.1, marginBottom: 16 }}>
              Blog
            </h1>
            <p style={{ fontSize: 16, color: 'var(--gray-2)', lineHeight: 1.7, maxWidth: 480 }}>
              Long-form thinking on DJ workflows, music metadata, and the tools that get out of your way.
            </p>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
            {posts.map((post, i) => (
              <motion.div
                key={post.id}
                initial={{ opacity: 0, y: 16 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                style={{ borderBottom: '1px solid var(--border)', paddingBottom: 40, marginBottom: 40 }}
              >
                <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 12, marginBottom: 16 }}>
                  <span style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 11, color: 'var(--gray-3)', letterSpacing: '0.05em' }}>
                    <Clock size={10} />
                    {post.readTime}
                  </span>
                  <span style={{ color: 'var(--gray-4)', fontSize: 11 }}>·</span>
                  <span style={{ fontSize: 11, color: 'var(--gray-3)', letterSpacing: '0.08em', textTransform: 'uppercase' }}>
                    {post.date}
                  </span>
                  <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
                    {post.tags.map(tag => (
                      <span
                        key={tag}
                        style={{
                          fontSize: 9,
                          letterSpacing: '0.1em',
                          textTransform: 'uppercase',
                          padding: '3px 8px',
                          border: '1px solid var(--border)',
                          borderRadius: 4,
                          color: 'var(--gray-3)',
                        }}
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>

                <h2 style={{
                  fontFamily: 'var(--heading)',
                  fontSize: 'clamp(1.4rem, 3vw, 1.75rem)',
                  fontWeight: 700,
                  letterSpacing: '-0.02em',
                  color: 'var(--white)',
                  marginBottom: 12,
                  lineHeight: 1.2,
                }}>
                  <Link
                    to={`/blog/${post.slug}`}
                    style={{
                      transition: 'color 0.2s',
                    }}
                    onMouseEnter={e => (e.target.style.color = 'var(--accent)')}
                    onMouseLeave={e => (e.target.style.color = 'var(--white)')}
                  >
                    {post.title}
                  </Link>
                </h2>

                <p style={{ fontSize: 15, color: 'var(--gray-2)', lineHeight: 1.7, marginBottom: 20 }}>
                  {post.excerpt}
                </p>

                <Link
                  to={`/blog/${post.slug}`}
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 6,
                    fontSize: 11,
                    letterSpacing: '0.1em',
                    textTransform: 'uppercase',
                    color: 'var(--gray-3)',
                    transition: 'color 0.2s',
                  }}
                  onMouseEnter={e => (e.target.style.color = 'var(--accent)')}
                  onMouseLeave={e => (e.target.style.color = 'var(--gray-3)')}
                >
                  Read article
                </Link>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </div>
  );
}
